<template>
    <div
        class="success-screen _bg-grey-106 _br-56-24 _pt-56-24 _pb-56-24 _pl-56-16 _pr-56-16"
        :class="{
            'success-screen_dark': dark,
            'success-screen_is-error': isError,
            'success-screen_premium': variant === 'premium',
        }"
    >
        <div class="success-screen__content">
            <h2 class="h2 _mb-16-8" v-html="title"></h2>
            <slot>
                <p class="p2" v-html="description"></p>
            </slot>
            <div
                v-if="$slots.append"
                class="_mt-24"
            >
                <slot name="append" />
            </div>
        </div>
        <div class="success-screen__img" />
    </div>
</template>
<script>
export default {
    name: 'SuccessScreen',
    props: {
        title: String,
        description: String,
        variant: {
            type: String,
            default: '',
            validator(value) {
                return !value || [
                    'premium',
                ].includes(value);
            },
        },
        dark: {
            type: Boolean,
            default: false
        },
        isError: Boolean,
    },
};
</script>
<style lang="scss">
@import "/local/templates/redesign/src/assets/scss/base/_variables.scss";
@import "/local/templates/redesign/src/assets/scss/base/_mixins.scss";
@import "/local/templates/redesign/src/assets/scss/base/_functions.scss";

.success-screen {
    --success-screen__img_success: url('/local/templates/redesign/src/assets/img/success.webp');
    --success-screen__img_success-mob: url('/local/templates/redesign/src/assets/img/success-mob.webp');
    --success-screen__img_error: url('/local/templates/redesign/src/assets/img/result_error.webp');
    --success-screen__img_error-mob: url('/local/templates/redesign/src/assets/img/result_error-mob.webp');
    --success-screen__img: var(--success-screen__img_success);
    --success-screen__img-mob: var(--success-screen__img_success-mob);

    position: relative;
    @include fluid('height', 352px);
    display: flex;
    align-items: center;

    @include mobile {
        height: auto;
        @include fluid('padding-top', 164px);
    }

    &_dark {
        background-color: $graphite-second;
        color: $white-101;
    }

    &_premium {
        --success-screen__img_success: url('/local/templates/redesign/src/assets/img/premium/form_bg_success.webp');
        --success-screen__img_success-mob: url('/local/templates/redesign/src/assets/img/premium/form_bg_success-mob.webp');
    }

    &_is-error {
        --success-screen__img: var(--success-screen__img_error);
        --success-screen__img-mob: var(--success-screen__img_error-mob);
    }

    &__content {
        @include fluid('width', 639px);

        @include mobile {
            width: 100%;
        }
    }

    &__img {
        @include fluid('border-radius', 56px);
        position: absolute;
        pointer-events: none;
        user-select: none;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        @include fluid('--bg-width', 486px);
        background: var(--success-screen__img) no-repeat right bottom / var(--bg-width) auto;

        @include mobile {
            @include fluid('height', 148px);
            background: var(--success-screen__img-mob) no-repeat center / 100% auto;
        }
    }
}
</style>
